Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.AntiAliasType = module.exports.default = {
	ADVANCED: "advanced",
	NORMAL: "normal"
};